<template>
  <span :class="classes" class="form-input">
    <input v-bind="$attrs" type="date" :value="value" v-on="eventListeners" />
  </span>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    value: {},
    shaded: {
      type: Boolean,
      required: false,
      default: false
    },
    stepping: {
      type: Boolean,
      required: false,
      default: false
    },
    withBorder: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    classes() {
      const classes = [this.$style.wrapper];

      if (this.shaded) {
        classes.push(this.$style.shaded);
      }

      if (!this.stepping) {
        classes.push(this.$style.noStepping);
      }

      if (this.withBorder) {
        classes.push(this.$style.whiteBackground);
      }

      return classes;
    },
    // https://vuejs.org/v2/guide/components-custom-events.html#Binding-Native-Events-to-Components
    eventListeners() {
      return Object.assign({}, this.$listeners, {
        input: event => {
          this.$emit('input', event.target.value);
        },
        mousewheel: event => {
          // Prevent stepping of values using mouse wheel
          // Chrome browser uses `mousewheel` event
          if (!this.stepping) {
            event.preventDefault();
          }
        },
        wheel: event => {
          // Prevent stepping of values using mouse wheel
          // Firefox browser uses `wheel` event
          if (!this.stepping) {
            event.preventDefault();
          }
        },
        keydown: event => {
          // Prevent stepping of values using arrow keys
          if (!this.stepping) {
            const ArrowUpKeyCode = 38;
            const ArrowDownKeyCode = 40;

            if (
              event.keyCode === ArrowUpKeyCode ||
              event.keyCode === ArrowDownKeyCode
            ) {
              event.preventDefault();
            }
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" module>
@import '../FormInput/FormInput.scss';
</style>
